import { render, staticRenderFns } from "./RTPlotTabs.vue?vue&type=template&id=552abe8f"
import script from "./RTPlotTabs.vue?vue&type=script&lang=js"
export * from "./RTPlotTabs.vue?vue&type=script&lang=js"
import style0 from "./RTPlotTabs.vue?vue&type=style&index=0&id=552abe8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports